<template>
  <div>
    <div class="line_text u-mg-b-4">
      <div class="line_text__sidebox"></div>
      <div class="line_text__text"><p>新規会員登録</p></div>
      <div class="line_text__sidebox"></div>
    </div>

    <div class="u-pd-r-1 u-pd-l-1">
      <!-- メールアドレスで登録 -->
      <a class="btn btn-block u-mg-b-3" data-color="brand" href="/user/input">メールアドレスではじめる</a>

      <!-- SNSアカウントで登録 -->
      <sns-register register-type="signup" :regist-token="registToken"></sns-register>
    </div>

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'sign-up-action-panel',
  props: {
    registToken: { type: String, default: ''},
  },
  computed: {
    ...mapState({
      authUser: state => state.auth.data
    })
  },
}</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/SignUpActionPanel.vue